<template>
  <div
    v-if="(totalNotification > 0 && $screen.width > 576) || (totalNotification - totalDocToSign > 0 && $screen.width <= 576)"
    class="account-notifications dropdown"
    :style="`${$screen.width <= 576 ? '' : 'margin-right: 25px;'}`"
  >
    <b-dropdown
      variant="link"
      size="md"
      :class="`notifications-dropdown${$screen.width <= 576 ? ' fix-notifications-for-pwa' : ''}${$isPwa() ? ' pwa' : ''}`"
      toggle-class="text-decoration-none"
      style="width: 30px"
      right
      no-caret
    >
      <template #button-content>
        <bell :size="18" />
        <b-badge pill class="badge-header badge-variant">{{ $screen.width > 576 ? totalNotification : totalNotification - totalDocToSign }}</b-badge>
      </template>
      <b-dropdown-header id="dropdown-header-label">
        {{ FormMSG(10, 'Your notifications') }}
      </b-dropdown-header>
      <b-dropdown-item v-if="totalDocToRead > 0" size="sm" action to="/mydocuments">
        {{ FormMSG(11, 'New Documents') }} <b-badge pil class="badge-variant">{{ totalDocToRead }}</b-badge>
      </b-dropdown-item>
      <!-- project/users -->
      <b-dropdown-item v-if="totalDocToSign > 0 && $screen.width > 576" size="sm" action :to="`${isDocManager ? '/project/users' : '/profile?forDocs=true'}`">
        {{ FormMSG(22, 'Documents to validate/sign') }} <b-badge pil class="badge-variant">{{ totalDocToSign }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item v-if="totalAccToRead > 0" action to="/myaccomodations">
        {{ FormMSG(12, 'New accomodations') }} <b-badge pill class="badge-variant">{{ totalAccToRead }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item v-if="totalTsToValidate > 0" action to="/mytimesheets">
        {{ FormMSG(13, 'Timesheets to validate') }} <b-badge pill class="badge-variant">{{ totalTsToValidate }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item v-if="totalExpToValidate > 0" action to="/myexpenses">
        {{ FormMSG(15, 'Expenses to validate') }} <b-badge pill class="badge-variant">{{ totalExpToValidate }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item v-if="totalPoToValidate > 0" action to="/mypo">
        {{ FormMSG(14, 'Purchase orders to validate') }} <b-badge pill class="badge-variant">{{ totalPoToValidate }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item v-if="totalTsRefused > 0" action to="/mytimesheets">
        {{ FormMSG(16, 'Timesheets refused') }} <b-badge pill class="badge-variant">{{ totalTsRefused }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item v-if="totalExpRefused > 0" action to="/myexpenses">
        {{ FormMSG(17, 'Expenses refused') }} <b-badge pill class="badge-variant">{{ totalExpRefused }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item v-if="totalPoRefused > 0" action to="/mypo">
        {{ FormMSG(18, 'Purchase orders refused') }} <b-badge pill class="badge-variant">{{ totalPoRefused }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item v-if="totalExpItemRefused > 0" action to="/myexpenses">
        {{ FormMSG(19, 'Expense items refused') }} <b-badge pill class="badge-variant">{{ totalExpItemRefused }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item v-if="useExpenseInvoiceProject && totalInvoiceToValidate > 0" action to="/myinvoices">
        {{ FormMSG(30, 'Invoice to validate') }} <b-badge pill class="badge-variant">{{ totalInvoiceToValidate }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item v-if="useExpenseInvoiceProject && totalInvoiceRefused > 0" action to="/myinvoices">
        {{ FormMSG(31, 'Invoice refused') }} <b-badge pill class="badge-variant">{{ totalInvoiceRefused }}</b-badge>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import languageMessages from '@/mixins/languageMessages';
import { Bell } from 'lucide-vue';
import globalMixin from '@/mixins/global.mixin';
import { getValidations } from '@/cruds/validations.crud';
import { store } from '@/store';

export default {
  name: 'HeaderNotifications',
  components: { Bell },
  mixins: [languageMessages, globalMixin],
  data() {
    return { erreur: {}, myerr: '' };
  },
  computed: {
    ...mapGetters({
      getMyProfile: 'profile/getMyProfile',
      totalNotification: 'header/getTotalNotification',
      totalDocToRead: 'header/getTotalDocToRead',
      totalDocToSign: 'header/getTotalDocToSign',
      totalAccToRead: 'header/getTotalAccToRead',
      totalTsToValidate: 'header/getTotalTsToValidate',
      totalPoToValidate: 'header/getTotalPoToValidate',
      totalExpToValidate: 'header/getTotalExpToValidate',
      totalExpItemRefused: 'header/getTotalExpItemRefused',
      totalTsRefused: 'header/getTotalTsRefused',
      totalPoRefused: 'header/getTotalPoRefused',
      totalExpRefused: 'header/getTotalExpRefused',
      totalInvoiceToValidate: 'header/getTotalInvoiceToValidate',
      totalInvoiceRefused: 'header/getTotalInvoiceRefused'
      // count: 'header/getCount',
    }),
    isDocManager() {
      if (
        this.getMyProfile &&
        (this.getMyProfile.upm ||
          this.getMyProfile.gateKeeper ||
          this.getMyProfile.productionAccountant ||
          this.getMyProfile.lineProducer ||
          this.getMyProfile.studio ||
          this.getMyProfile.canValidateI9) &&
        this.getProjectConfigProperty('useDocument')
      ) {
        return true;
      }

      return false;
    },
    useExpenseInvoiceProject() {
      return this.getProjectConfigProperty('useExpenseInvoice');
    }
  },
  async created() {
    await this.getNotifications().catch((error) => {
      console.error({ error });
    });
  },
  methods: {
    ...mapActions({
      getNotifications: 'header/getNotifications'
    }),
    handleClick(screen) {
      if (this.$screen.width <= 576) {
        this.createToastForMobile(
          this.FormMSG(20, 'Not allowed'),
          this.FormMSG(21, "It's currrently not possible to do approval from a mobile device. To access the approval screens, please use a computer."),
          '',
          'danger'
        );
      } else {
        this.$router.push(`/${screen}/?validate=true`);
      }
    }
  }
};
</script>

<style lang="scss">
.fix-notifications-for-pwa {
  margin-left: -2px;
  margin-right: 16px;
  &.show {
    &.pwa .dropdown-menu {
      top: 80px !important;
    }
  }
}

.notifications-dropdown button {
  padding: 0;
}

.badge-header {
  position: absolute !important;
  margin-top: -2px;
  font-size: 77.5%;
}

.badge-variant {
  color: #ea4e2c;
  letter-spacing: 0.03rem;
  background-color: #fcede9;
}
</style>
